import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SystemIconComponent } from './system-icon/system-icon.component';



@NgModule({
  declarations: [
    SystemIconComponent
  ],
  imports: [
    CommonModule
  ],
  exports: [
    SystemIconComponent
  ]
})
export class SystemIconModule { }
